export enum QuestionStatus {
  Open = 'open',
  NeedReview = 'need_review',
  Closed = 'closed',
}

export const QUESTION_STATUS_LABELS: Record<QuestionStatus, string> = {
  [QuestionStatus.Open]: 'مفتوح',
  [QuestionStatus.NeedReview]: 'تحتاج مراجعة',
  [QuestionStatus.Closed]: 'مغلق',
};

export interface QuestionClient {
  id: number;
  first_name: string;
  last_name: string;
  email?: string;
  mobile?: string;
  avatar?: string | null;
}

export interface QuestionSpecialization {
  id: number;
  name_ar?: string;
  name_en?: string;
}

export interface QuestionCohort {
  id: number;
  name: string;
}

export interface QuestionAttachment {
  id: number;
  question: number;
  file_url: string;
  file_name: string;
  created_at: string;
}

export interface Question {
  id: number;
  client?: QuestionClient;
  specialization?: QuestionSpecialization;
  content?: string;
  status?: string;
  answers_count?: number;
  accepted_at?: string | null;
  closed_at?: string | null;
  created_at?: string;
  cohort?: QuestionCohort;
  accepted_by?: number | null;
  closed_by?: number | null;
  attachments_safety?: string | null;
  pii_safety?: string | null;
  relevance_safety?: string | null;
  ai_responses?: unknown[];
  created_by?: number;
  attachments?: QuestionAttachment[];
}

export interface QuestionsQueryParams {
  page?: number;
  page_size?: number;
  status?: string;
  query?: string;
  [key: string]: string | number | string[] | undefined;
}

export interface QuestionsListResponse {
  meta?: {
    pagination?: {
      count?: number;
      pages_count?: number;
      page?: number;
    };
  };
  data: Question[];
  error?: string | null;
}

export interface QuestionDetailResponse {
  meta?: {
    status?: string;
    code?: number;
  };
  data: Question;
  error?: string | null;
}

export interface QuestionUpdatePayload {
  status?: string;
  specialization?: number;
}

export interface DashboardSummary {
  open_questions_count: number;
  under_review_questions_count: number;
  active_cohort: QuestionCohort | null;
}

export interface DashboardSummaryResponse {
  data: DashboardSummary;
  error?: string | null;
}
